import React, { FC } from 'react';
import { Grid, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { IMGIX_HOST } from 'settings';
import { generateLink } from 'Links';
import { getAppImage, getImageSrc } from 'helpers';
import { APP_IMAGES } from 'app-constants';
import { ContentFragment } from 'api';

import { getImage } from 'features/content/helpers';

interface Props {
  size: number;
  content: ContentFragment;
}

const useStyles = makeStyles(theme => ({
  image: {
    height: ({ size }: Props) => size,
    width: ({ size }: Props) => size,
  },
  imageBorder: {
    height: ({ size }: Props) => size,
    width: ({ size }: Props) => size,
    border: `1px solid ${theme.palette.grey[300]}`,
    position: 'relative',
  },
  noImage: {
    position: 'absolute',
    textAlign: 'center',
  },
}));

const PostImage: FC<Props> = props => {
  const { content, size } = props;
  const classes = useStyles(props);
  const { t } = useTranslation();
  const image = getImage(content);

  function getImgixUrl() {
    const key = image.file_key ? image.file_key : image.key;
    const baseUrl = `${IMGIX_HOST}/${key}`;
    const params = `auto=format&fit=crop&crop=faces&w=${size}&h=${size}`;

    return `${baseUrl}?${params}`;
  }

  function renderPlaceholderImage() {
    let children = null;

    if (content) {
      children = (
        <Link component={generateLink(`/content/${content.content_id}`)}>
          <img className={classes.image} {...getAppImage(APP_IMAGES.SocialLoading)} />
        </Link>
      );
    } else {
      children = <img className={classes.image} {...getAppImage(APP_IMAGES.SocialLoading)} />;
    }

    return (
      <Grid container alignItems="center" justify="center" className={classes.imageBorder}>
        <Typography className={classes.noImage}>{t('admin:noPreview')}</Typography>
        {children}
      </Grid>
    );
  }

  if (!image || !image.bucket) {
    return renderPlaceholderImage();
  }

  const imageUrl = getImgixUrl();

  return (
    <Link component={generateLink(`/content/${content.content_id}`)}>
      <div className={classes.imageBorder}>
        <img {...getImageSrc(imageUrl)} />
      </div>
    </Link>
  );
};

PostImage.defaultProps = {
  size: 200,
};

export default PostImage;
